import { AffiliateSilentCard } from '@/components/companion/cards/AffiliateSilentCard';
import { BrandmatchBatchCard } from '@/components/companion/cards/BrandmatchBatchCard';
import { BriefApplicationCard } from '@/components/companion/cards/BriefApplicationCard';
import { GiftStockCard } from '@/components/companion/cards/GiftStockCard';
import { GiftUnclaimedCard } from '@/components/companion/cards/GiftUnclaimedCard';
import { GiftExpiredReofferCard } from '@/components/companion/cards/GiftExpiredReofferCard';
import { MentionNotableCard } from '@/components/companion/cards/MentionNotableCard';
import { PayoutPendingCard } from '@/components/companion/cards/PayoutPendingCard';
import { RightsExpiringCard } from '@/components/companion/cards/RightsExpiringCard';
import { createCompanionPresenter } from '@/components/companion/feed/presenters/create-companion-presenter';
import { GenericActionCard } from '@/components/companion/feed/presenters/GenericActionCard';
import type { CompanionPresenter } from '@/components/companion/feed/presenters/presenter-types';
import type { CompanionActionKind } from '@fluenceur/types';

/**
 * One presenter per kind, resolved at render time.
 *
 * The map is deliberately partial: kinds ship one tranche at a time, and a kind
 * that reaches the panel before its presenter does gets the generic card rather
 * than a blank space. Adding a kind here is the whole registration.
 */
const PRESENTERS: Partial<Record<CompanionActionKind, CompanionPresenter>> = {
  affiliate_silent: createCompanionPresenter('affiliate_silent', AffiliateSilentCard),
  brandmatch_batch: createCompanionPresenter('brandmatch_batch', BrandmatchBatchCard),
  brief_application: createCompanionPresenter('brief_application', BriefApplicationCard),
  gift_stock: createCompanionPresenter('gift_stock', GiftStockCard),
  gift_unclaimed: createCompanionPresenter('gift_unclaimed', GiftUnclaimedCard),
  gift_expired_reoffer: createCompanionPresenter('gift_expired_reoffer', GiftExpiredReofferCard),
  mention_notable: createCompanionPresenter('mention_notable', MentionNotableCard),
  payout_pending: createCompanionPresenter('payout_pending', PayoutPendingCard),
  rights_expiring: createCompanionPresenter('rights_expiring', RightsExpiringCard),
};

export const resolveCompanionPresenter = (kind: CompanionActionKind): CompanionPresenter =>
  PRESENTERS[kind] ?? GenericActionCard;

export { createCompanionPresenter };
export type { CompanionPresenter, CompanionPresenterProps } from './presenter-types';
